import { NoticeOrErrorModel } from '../../models/notice.error.model';
import { ProductModel } from '../../models/products.model';
import { AppState } from '../store';

export const collectionData = (state: AppState): string[] => state.collection.collection;

export const collectionProductsData = (state: AppState): ProductModel[] => state.collection.collectionProducts.data;

export const collectionProductsNotices = (state: AppState): NoticeOrErrorModel[] | undefined =>
    state.collection.collectionProducts.notices;
